import { Box, CircularProgress, Typography } from '@mui/material';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';

interface ValidationProgressProps {
  message: string;
  // Mensaje secundario opcional — úsalo para informar al usuario que puede
  // cerrar el widget y regresar después sin perder el progreso.
  hint?: string;
}

// Pantalla de espera mientras el backend valida el documento
export function ValidationProgress({ message, hint }: ValidationProgressProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        py: 8,
        gap: 2,
      }}
    >
      <Box sx={{ position: 'relative', display: 'inline-flex', mb: 1 }}>
        <CircularProgress size={64} thickness={2.5} />
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <HourglassEmptyIcon sx={{ fontSize: 28, color: 'primary.main' }} />
        </Box>
      </Box>

      <Typography variant="body1" color="text.secondary" align="center">
        {message}
      </Typography>

      {/* Indicador de actividad separado del texto para evitar saltos visuales */}
      <Typography
        variant="body2"
        color="text.disabled"
        align="center"
        sx={{
          letterSpacing: '0.3em',
          animation: 'pulse-opacity 1.4s ease-in-out infinite',
          '@keyframes pulse-opacity': {
            '0%, 100%': { opacity: 0.2 },
            '50%':       { opacity: 1   },
          },
        }}
      >
        ···
      </Typography>

      {hint && (
        <Typography
          variant="body2"
          color="text.secondary"
          align="center"
          sx={{ maxWidth: 300, mt: 1, lineHeight: 1.6 }}
        >
          {hint}
        </Typography>
      )}
    </Box>
  );
}
